module.exports = __webpack_public_path__ + "img/banner.e4639ec.png";